import { useLayoutEffect, useEffect } from 'react';

function dispatchEvent(type, detail) {
  window.dispatchEvent(new CustomEvent(type, {
    detail
  }));
}

var useIsomorphicEffect = typeof window !== "undefined" ? useLayoutEffect : useEffect;

function createUseExternalEvents(prefix) {
  function _useExternalEvents(events) {
    var handlers = Object.keys(events).reduce(function (acc, eventKey) {
      acc["".concat(prefix, ":").concat(eventKey)] = function (event) {
        return events[eventKey](event.detail);
      };

      return acc;
    }, {});
    useIsomorphicEffect(function () {
      Object.keys(handlers).forEach(function (eventKey) {
        window.removeEventListener(eventKey, handlers[eventKey]);
        window.addEventListener(eventKey, handlers[eventKey]);
      });
      return function () {
        return Object.keys(handlers).forEach(function (eventKey) {
          window.removeEventListener(eventKey, handlers[eventKey]);
        });
      };
    }, [handlers]);
  }

  function createEvent(event) {
    return function () {
      return dispatchEvent("".concat(prefix, ":").concat(String(event)), arguments.length <= 0 ? undefined : arguments[0]);
    };
  }

  return [_useExternalEvents, createEvent];
}

export { createUseExternalEvents };